import React, {Component} from "react"
import {PATH_ENTERPRISE_ACCOUNT_USER_REPORT_SINGLE} from "../../../constants"
import {connect} from "react-redux"
import {injectIntl} from "react-intl"
import config from "../../../config"

function mapStateToProps(state, ownProps) {

  const user = state.user
  const locale = state.locale


  return {
    user,
    locale,
  }
}

const mapDispatchToProps = {}

class DownloadReportButton extends Component {

  constructor() {
    super()
    this.state = {
      reportLoading: false
    }
  }

  render() {

    const component = this

    const format = this.props.intl.formatMessage

    const user = this.props.user
    const locale = this.props.locale
    const userId = this.props.userId
    const extraParams = this.props.extraParams || {}
    const style = this.props.style || 'primary'

    const application = op.get(user, 'currentApplication.name', 'memorie')

    const token = user.access_token
    const type = user.token_type
    const {api_server_host} = config

    const accountId = op.get(user, 'currentEnterpriseAccount.id')


    const isEnabled = accountId && !this.state.reportLoading

    return (
      <div className={`btn btn-${style} ${!isEnabled ? 'disabled' : 'custom-link'} `}
           onClick={() => {

             if (!isEnabled) return

             component.setState({reportLoading: true})

             let path = `${api_server_host}${PATH_ENTERPRISE_ACCOUNT_USER_REPORT_SINGLE}?userId=${userId}&accountId=${accountId}&locale=${locale}&application=${application}`

             fetch(path
               , {
                 headers: {
                   Authorization: `${type} ${token}`
                 },
                 body: JSON.stringify(extraParams),
                 method: 'POST'
               }).then((response) => {
               return response.json()
             }, (error) => {
               component.setState({reportLoading: false})
               alert(error)
             }).then((json) => {
               component.setState({reportLoading: false})
               window.location = json.url
             })

           }}
      >
        {this.state.reportLoading ? `${format({id:'generating.report'})} ...` : `${format({id:"download.report"})} ${extraParams?extraParams.index:""}`}
      </div>
    )

  }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(DownloadReportButton))



// WEBPACK FOOTER //
// ./src/routes/enterprise/components/DownloadReportButton.js